import Types from './Types';

export const createStudentExamsRequest = (data, action) => ({
    type: Types.CREATE_STUDENT_EXAMS_REQUEST,
    payload: data,
    action: action
});

export const createStudentExamsSuccess = () => ({
    type: Types.CREATE_STUDENT_EXAMS_SUCCESS,
});

export const createStudentExamsFail = () => ({
    type: Types.CREATE_STUDENT_EXAMS_FAIL
});

export const createTagExamRequest = (data, action) => ({
    type: Types.CREATE_TAG_EXAM_REQUEST,
    payload: data,
    action,
});

export const createTagExamSuccess = (data) => ({
    type: Types.CREATE_TAG_EXAM_SUCCESS,
    payload: data,
});

export const createTagExamFail = () => ({
    type: Types.CREATE_TAG_EXAM_FAIL,
});

export const restoreTagExamSession = (data) => ({
    type: Types.RESTORE_TAG_EXAM_SESSION,
    payload: data,
});

export const clearTagExamSessionState = () => ({
    type: Types.CLEAR_TAG_EXAM_SESSION,
});

export const getStudentExamsRequest = (id) => ({
    type: Types.GET_STUDENT_EXAMS_REQUEST,
    payload: id
});

export const getStudentExamsSuccess = (data) => ({
    type: Types.GET_STUDENT_EXAMS_SUCCESS,
    payload: data
});

export const getStudentExamsFail = () => ({
    type: Types.GET_STUDENT_EXAMS_FAIL
});

export const getStudentTagsRequest = () => ({
    type: Types.GET_STUDENT_TAGS_REQUEST,
});

export const getStudentTagsSuccess = (data) => ({
    type: Types.GET_STUDENT_TAGS_SUCCESS,
    payload: data,
});

export const getStudentTagsFail = () => ({
    type: Types.GET_STUDENT_TAGS_FAIL,
});

export const getStudentExamQuestionsRequest = (id) => ({
    type: Types.GET_STUDENT_EXAM_QUESTIONS_REQUEST,
    payload: id
});

export const getStudentExamQuestionsSuccess = (data) => ({
    type: Types.GET_STUDENT_EXAM_QUESTIONS_SUCCESS,
    payload: data
});

export const getStudentExamQuestionsFail = (errorInfo) => ({
    type: Types.GET_STUDENT_EXAM_QUESTIONS_FAIL,
    payload: errorInfo,
});

export const addStudentExamsLoading = (isLoading) => ({
    type: Types.ADD_STUDENT_EXAMS_LOADING,
    payload: isLoading
});

export const addStudentExamsCreating = (isCreating) => ({
    type: Types.ADD_STUDENT_EXAMS_CREATING,
    payload: isCreating,
});

export const addStudentTagsLoading = (isLoading) => ({
    type: Types.ADD_STUDENT_TAGS_LOADING,
    payload: isLoading,
});
